import proj4 from "proj4";
import type { Feature, Polygon } from "geojson";

const PT_TM06 =
  "+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";

proj4.defs("EPSG:3763", PT_TM06);

function parseWktPolygonPoints(wkt: string): [number, number][] {
  const match = /POLYGON\s*\(\(([^)]+)\)\)/i.exec(wkt);
  if (!match) return [];

  return match[1].split(",").map((pair) => {
    const [x, y] = pair.trim().split(/\s+/).map(Number);
    return [x, y];
  });
}

export function wktPolygonToGeoJson(wkt: string, sourceEpsg = "EPSG:3763"): Feature<Polygon> | null {
  const points = parseWktPolygonPoints(wkt);
  if (points.length === 0) return null;

  const wgs84Points = points.map(([x, y]) => proj4(sourceEpsg, "EPSG:4326", [x, y]));

  return {
    type: "Feature",
    properties: {},
    geometry: {
      type: "Polygon",
      coordinates: [wgs84Points],
    },
  };
}